let agentList = [
  {
    Q:'J-DIRECTが接続できません。どうしたらいいですか？',
    A1:'インターネット環境が正常であるかをご確認ください。',
    A2:'J-DIRECTの契約が有効期限切れの場合は、追加購入する必要があります。視聴を終える際には、必ずリモコンでBOXの電源をOFFにしてください。',
    A3:'※電源OFFにしない場合、J-DIRECTの再接続に時間がかかる場合があります。'
  },
  {
    Q:'J-DIRECTのボックスのWiFiが使えません。どうしてですか？',
    A1: 'ボックスのWiFi機能を使うには、ボックス自体を有線LANでインターネットに接続しておく必要があります。',
    A2:'本体が無線LANでしかインターネットに接続できない場合は、WiFi電波を出すことはできません。'
  },
  {
    Q:'J-Directの接続のみで見られる無料アプリは何ですか？',
    A1:'プリインストールされているAbema、GYAO、TVerの一部サービスは無料でご利用可能です。'
  },
  {
    Q:'有料コンテンツサービスの加入代行は行っておりますか？',
    A1:'弊社では各サービスの加入は行っておりませんので、お客様自身でのご加入、お支払いをお願い致します。'
  },
  {
    Q:'J-DIRECTにお気に入りアプリを追加したい。',
    A1:'追加したいアプリがインストールされていることを確認してください。',
    A2:'J-DIRECTホーム画面下にある【＋】を選択し、お気に入り追加したいアプリを選択すると追加できます。'
  },
  {
    Q:'NetflixやAmazonPrimeVideoをリモコンで操作できません。',
    A1:'Netflixはタブレット版がインストールされており、リモコンで一部操作が行えません。同梱の指マウスと併用してご利用ください。'
  },
  {
    Q:'Googleのホームページで日本の番組が見れないのはなぜですか？',
    A1:'日本IP VPNの接続にするには、J-DIRECTのアプリ経由からアクセスしてご利用する必要があります。'
  },
  {
    Q:'画質が粗くなる場合があります。',
    A1:'一部アプリは、ネット回線が不安定の場合に、自動で画質調整されて配信されます。'
  },
  {
    Q:'画像が頻繁に止まりますが、なぜですか？',
    A1:'ご利用のネット環境の回線が不安定であったり、回線速度が遅い場合は、J-DIRECTの接続を確立できずに、止まりやすくなったり、繋がらない場合がございます。'
  },
  {
    Q:'自動で接続が途切れてしましました。',
    A1:'接続開始後、180分を経過すると、セキュリティのため自動で切断されるようになっております。',
    A2:'継続してご利用の場合は再度、接続を行ってください。'
  },
  {
    Q:'自動で接続が途切れた後から再接続ができません。',
    A1:'リモコンの電源ボタンを長押し→再起動後に再接続を行ってください。'
  },
  {
    Q:'J-DIRECTを購入する場合は、どうすればいいですか？',
    A1:'メニュー内の【購入】よりご希望の期間を選択し、スマートフォンなどでQRコードをスキャンし、Paypalでのオンライン決済を行って下さい。'
  },
  {
    Q:'途中解約は可能でしょうか？',
    A1:'途中解約は行えませんので予めご了承ください。'
  },
  {
    Q:'J-DIRECTの契約情報を確認したい。',
    A1:'J-DIRECTホーム画面左上の三を押しメニュー画面に移動後、表示されるマイIDをご確認ください。'
  },
  {
    Q:'リセット/データの初期化を行いたい。',
    A1:'ホーム画面最下部の設定から、設定→ストレージとリセット→データの初期化を選択してください。'
  },
  {
    Q:'リセット/データの初期化でどんな情報がリセットされますか？',
    A1:'地域情報/Googleアカウント情報/J-DIRECT内に追加されたショートカットの情報などがリセットされます。'
  },
  {
    Q:'J-DIRECT BOXをWiFiに接続したい。',
    A1:'ホーム画面最下部の設定から、設定→ネットワークから利用可能なネットワークを選択して、WiFiに接続してください。'
  },
  {
    Q:'スクリーンセーバーを設定したい。',
    A1:'ホーム画面最下部の設定から、設定→スクリーンセーバーから設定してください。'
  },
  {
    Q:'マウスやキーボード等のアクセサリを追加したい。',
    A1:'ホーム画面最下部の設定から、設定→アクセサリを追加から設定してください。'
  },
  {
    Q:'時計を住んでいる国の現地時刻に合わせたい。',
    A1:'ホーム画面最下部の設定から、設定→日付と時刻→タイムゾーンの設定からお住いの地域を選択してください。'
  }
]
export default agentList


// WEBPACK FOOTER //
// ./src/data-js/agent/index.js